import React, { Fragment, Component } from "react";
import WordOnImgDropItemUI from "./WordOnImgDropItemUI";

import CenterElement from "../../activity/activityComponent/CenterElement";

class WordOnImgDropItemContainer extends Component {
  // componentDidMount = () => {
  //     window.x(this.dropText)
  // }
  render = () => {
    let { activity, quizViewer } = this.props;
    let { quizViwerModel } = quizViewer.state;
    let { dropItemContainer } = activity;
    let { dropItemList, mainImgsrc, selectedStyle } = dropItemContainer;
    let imgsrc = dropItemContainer.hasExternalUrl
      ? mainImgsrc
      : quizViwerModel.imgRes + mainImgsrc;
    return (
      <Fragment>
        <div
          style={{
            textAlign: "center",
            marginTop: "3rem",
            display: "flex",
            justifyContent: "center",
            marginBottom: "3rem",
          }}
        >
          {!dropItemContainer.hasOnlyDropItems ? (
            <>
              <div hidden={!dropItemContainer.showImg}>
                {/* style={selectedStyle[1].style} */}
                <img
                  style={{ width: "100%" }}
                  src={imgsrc}
                  onClick={this.showImgRes}
                />
              </div>
              <div hidden={dropItemContainer.showImg}>
                {/* <EditorContainer onChange={this.handleTxtChange} content={quizViewer.getTxt(dropItemContainer.mainTxt)} /> */}
              </div>
              <CenterElement
                content={dropItemContainer.mainTxt}
              ></CenterElement>
            </>
          ) : (
            <></>
          )}

          {dropItemList.map((dropItem, index) => {
            return (
              <Fragment key={index}>
                <WordOnImgDropItemUI
                  autoPosition={dropItemContainer.hasOnlyDropItems}
                  activity={activity}
                  dropItem={dropItem}
                  quizViewer={quizViewer}
                />
              </Fragment>
            );
          })}
        </div>
      </Fragment>
    );
  };
}
export default WordOnImgDropItemContainer;
